import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Strings, { LVStrings, ServiceDescriptions, ServiceKeywords } from "@my-dld/assets/strings";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";
import PageContentX from "@my-dld/components/PageContentX";
import TextInputField from "@eres/forms-web/TextInputField";
import StateHolder from "@eres/forms/StateHolder";
import { EJARI_USER, TABU_OWNER } from "@10x/sso/roles";
import { LocaleUtil } from "@eres/core";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { ServiceCard } from "@my-dld/components/ServiceContainer";
import { getLocalValue, LocaleValue } from "@eres/core/dist/LocaleValue";
import { navigate } from "@my-dld/utils/StoreUtils";
import { getAppServices } from "@10x/coreapp";
import { ProcedureIDs } from "@10x/tabu-mobile-api/dist/requests/entity";
import { Gated } from "@10x/feature-gate";
import { ITabuSmartService, TabuRequestUtils } from "@10x/tabu-mobile-api";
import { convertTabuServiceToPropertyService } from "@my-dld/utils/PropertyUtils";
import { MyRequestServices } from "@my-dld/utils/TabuUtils";
import _ from "lodash";
import { UaePassUserFilter } from "@my-dld/utils/Utils";

interface Props  {
	// extends RoutedViewProps
}

interface State {
	allServices: ServiceCard[];
	searchKey?: string;
}

class MyRequestsServices extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		const mss = getAppServices().myRequestsService.getServices().map( ms => {
			return {
				...ms,
				action: () => {
					ms.action( ms );
				}
			};
		} );
		let allServices = [ ...RequestsServices, ...mss ];
		allServices = allServices.filter( UaePassUserFilter );
		this.state = {
			allServices: allServices,
		};
	}

	render() {
		// title={ Strings.my_requests }
		return <>
			<PageTitle paths={ [ DashboardBCItem ] } title={ Strings.my_requests }/>
            <div className=" page-function">
                <div className="position-relative w-100">
                    <TextInputField
                        id={"searchKey"}
                        label={Strings.search}
                        labelClassName="sr-only"
                        hideLabel={true}
                        holder={StateHolder.buildStateHolder(this)}
                        placeHolder={Strings.search} inputClassName="form-control search-field-icon" children={<button className="btn txt-clear-btn" type="button" id="txt_clear_btn"><i className="material-icons-outlined">close</i></button>} />
                    
                </div>
			</div>
			<div className={ "row my-dld-action head-card g-3" }>
				{ this.getFilteredServices().map( ( item: ServiceCard ) => {
					return this.renderItem( item );
				} ) }
			</div>
		</>;
	}

	private getFilteredServices() {
		const { searchKey, allServices } = this.state;
		let services = allServices;
		if ( searchKey && !isEmptyStringOrNull( searchKey.trim() ) ) {
			services = allServices.filter( s => filterServiceForSearch( s, searchKey.toLocaleLowerCase() ) );
		}
		services = _.sortBy( services, service => {
			const name = service.label ? ( typeof service.label !== "string" ? getLocalValue( ( service.label as LocaleValue ) ) : service.label ) : "";
			return name.toLocaleLowerCase().trim();
		} );
		return services;
	}

	private renderItem( item: ServiceCard ) {
		if ( item.hide )
			return;
		const id = item.id;
		const name = item.label ? ( typeof item.label !== "string" ? getLocalValue( ( item.label as LocaleValue ) ) : item.label ) : undefined;
		const desc = LocaleUtil.getLocalValue( item.descriptionProvider[ id ] );
		const Card = <div key={ id } className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 ">
			<a
				href="#" className="card"
				onClick={ e => {
					e.preventDefault();
					if ( item.action )
						item.action( id );
				} }>
				<span className="service-icon"><i className={ "icon-mydld-" + id }></i></span>
				{ item.count !== undefined && item.count !== 0 &&
					<span className="badge-count">{ item.count }</span> }
				<span className="service-name">{ name }</span>
				<span className="service-description">
						{ desc }
					</span>

			</a>
		</div>;
		if ( item.requiredFeature ) {
			return <Gated featureId={ item.requiredFeature } key={ item.id }>{ Card }</Gated>;
		}
		return Card;
	}
}

function CTS( tabuSvc: ITabuSmartService, extra?: Partial<ServiceCard> ): ServiceCard {
	return convertTabuServiceToPropertyService( tabuSvc, handleAction,
		{ userRole: TABU_OWNER.id, descriptionProvider: ServiceDescriptions, ...extra } );
}

const RequestsServices: ServiceCard[] = [
	...MyRequestServices.map( x => CTS( x ) ),
	{
		id: "rt_office_transaction_requests",
		label: LVStrings.rt_office_transaction_requests,
		userRole: TABU_OWNER.id,
		allowUnverifiedEmailUsers: true,
		action: handleAction,
		descriptionProvider: ServiceDescriptions,
	},
	{
		id: "board_members",
		label: LVStrings.owner_committee_reg,
		userRole: TABU_OWNER.id,
		allowUnverifiedEmailUsers: true,
		action: handleAction,
		descriptionProvider: ServiceDescriptions,
	},
	{
		id: "rvs_complaints",
		label: LVStrings.my_complaints,
		userRole: TABU_OWNER.id,
		allowUnverifiedEmailUsers: true,
		action: handleAction,
		descriptionProvider: ServiceDescriptions,
	},
	{
		id: "tasken",
		label: LVStrings.tasken,
		userRole: TABU_OWNER.id,
		hide: true,
		allowUnverifiedEmailUsers: true,
		action: handleAction,
		descriptionProvider: ServiceDescriptions,
	},
	{
		id: "third_party_valuation",
		label: LVStrings.third_party_valuation,
		userRole: TABU_OWNER.id,
		allowUnverifiedEmailUsers: true,
		action: handleAction,
		descriptionProvider: ServiceDescriptions,
	},
	{
		id: "mortgage_quotation",
		label: LVStrings.mortgage_quotation,
		userRole: TABU_OWNER.id,
		allowUnverifiedEmailUsers: true,
		action: handleAction,
		descriptionProvider: ServiceDescriptions,
	},
	{
		id: "my_sell_requests",
		label: LVStrings.my_sell_requests,
		userRole: TABU_OWNER.id,
		allowUnverifiedEmailUsers: true,
		action: handleAction,
		descriptionProvider: ServiceDescriptions,
		requireUaePassUser: true,
	},
	{
		id: "rental_valuation",
		label: LVStrings.rental_evaluation,
		userRole: TABU_OWNER.id | EJARI_USER.id,
		hide: true,
		allowUnverifiedEmailUsers: true,
		action: handleAction,
		descriptionProvider: ServiceDescriptions,
	},
	{
		id: "enoc_mollak",
		label: LVStrings.enoc_request,
		userRole: TABU_OWNER.id,
		allowUnverifiedEmailUsers: true,
		action: handleAction,
		descriptionProvider: ServiceDescriptions,
	},
	{
		id: "jop_services",
		label: LVStrings.jop_services,
		userRole: TABU_OWNER.id,
		allowUnverifiedEmailUsers: false,
		action: handleAction,
		descriptionProvider: ServiceDescriptions,
	},
];

function filterServiceForSearch( svc: ServiceCard, lowerCaseFilter: string ): boolean {
	const enValue = svc.label ? ( typeof svc.label !== "string" ? ( svc.label as LocaleValue ).en : svc.label ) : undefined;
	const arValue = svc.label ? ( typeof svc.label !== "string" ? ( svc.label as LocaleValue ).ar : svc.label ) : undefined;
	let valid = stringMatch( lowerCaseFilter, enValue ) || stringMatch( lowerCaseFilter, arValue );
	if ( !valid ) {
		// @ts-ignore
		const descEn = LocaleUtil.getLocalValue( ServiceDescriptions[ svc.id ], "en" );
		// @ts-ignore
		const descAr = LocaleUtil.getLocalValue( ServiceDescriptions[ svc.id ], "ar" );
		valid = stringMatch( lowerCaseFilter, descEn ) || stringMatch( lowerCaseFilter, descAr );
	}
	if ( !valid ) {
		// @ts-ignore
		const keyEn = LocaleUtil.getLocalValue( ServiceKeywords[ svc.id ], "en" );
		// @ts-ignore
		const keyAr = LocaleUtil.getLocalValue( ServiceKeywords[ svc.id ], "ar" );
		valid = stringMatch( lowerCaseFilter, keyEn ) || stringMatch( lowerCaseFilter, keyAr );
	}
	return valid;
}

function stringMatch( lowerCaseFilter: string, source?: string ) {
	if ( source != undefined ) {
		return source.toLowerCase().includes( lowerCaseFilter );
	}
	return false;
}

function handleTabuService( id: string ) {
	const tsv = TabuRequestUtils.getTabuServiceByStringId( id );
	if ( tsv ) {
		const Id = tsv.Id as ProcedureIDs;
		switch ( Id ) {
			default:
				navigate( `/mydld/my_requests/tabu/${ Id }` );
				return true;
		}

	}
	return false;
}

function handleAction( id: string ) {
	if ( !handleTabuService( id ) ) {
		switch ( id ) {


			case "rt_office_transaction_requests":
				navigate( `/mydld/my_requests/rt` );
				break;

			case "board_members":
				navigate( `/mydld/my_requests/owner_committee` );
				break;

			case "rvs_complaints":
				navigate( `/mydld/my_requests/complaints` );
				break;

			case "tasken":
				break;

			case "third_party_valuation":
				navigate( `/mydld/my_requests/external_valuation` );
				break;

			case "mortgage_quotation":
				navigate( `/mydld/my_requests/mortgage_quotation` );
				break;

			case "enoc_mollak":
				navigate( `/mydld/my_requests/enoc_mollak` );
				break;
			case "my_sell_requests":
				navigate( `/mydld/my_requests/privateSell` );
				break;
			case "jop_services":
				navigate( "/mydld/jop/requests" );
				break;
		}
	}
}

export default MyRequestsServices;

